import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import TopHeader from '../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { PvMonitoringContext } from '../../../../context/PvMonitoringContext';
import { PASS_KEY, WEB_KEY } from '../../../../api/AxiosApi';
import PrAnalysisTab1 from './prAnalysisTabs/PrAnalysisTab1';
import PrAnalysisTab3 from './prAnalysisTabs/PrAnalysisTab3';
import PrAnalysisTab4 from './prAnalysisTabs/PrAnalysisTab4';
import PrAnalysisTab2 from './prAnalysisTabs/PrAnalysisTab2';
import PrAnalysisTab5 from './prAnalysisTabs/PrAnalysisTab5/PrAnalysisTab5';


export default function PrAnalysis() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    // const [FromDate, setFromDate] = useState(getDateTimeForTab3().LastDay)
    // const [ToDate, setToDate] = useState(getDateTimeForTab3().Today)

    const [key, setKey] = useState('Performance');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    return (
        <Box>
            <CssBaseline />
            <TopHeader />
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                    PR-analysis
                    </NavLink>
                    {/* <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {location.pathname}
                    </NavLink> */}
                </Stack>
                <Tabs
                    style={{ justifyContent: "flex-end" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    
                    <Tab eventKey="Performance" title="Performance">
                    <PrAnalysisTab2/>
                    
                    </Tab>

                    <Tab eventKey="MIS_1" title="MIS_1">
                    
                    <PrAnalysisTab1/>
                    </Tab>

                    <Tab eventKey="MIS_2" title="MIS_2">
                        <PrAnalysisTab4/>
                    </Tab>

                    <Tab eventKey="Solar Irradiance" title="Solar Irradiance">
                        <PrAnalysisTab3/>
                    </Tab>

                    <Tab eventKey="Performance Power" title="Performance Power">
                        <PrAnalysisTab5/>
                    </Tab>
                    

                    
                </Tabs>
            </Box>
        </Box>

    )
}